module.exports = __webpack_public_path__ + "static/media/report_feedback_dude2.23af0adf.jpg";